/**
 * 公共接口
 */
import config from '@/config/index.js';
import code from './code.js';
import acc from './acc.js';
import area from './area.js';

// 请求
const configCarV2 = {
    url: `/beyonder/api/v2/config/{mode}`,
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
const configFeedback = {
    url: `/beyonder/api/v1/config/feedback`,
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

export default {
    configCarV2,
    configFeedback,
    ...area,
    ...code,
    ...acc
};



// WEBPACK FOOTER //
// ./src/service/common/index.js